import { TransitionActions, TransitionProps } from 'react-transition-group/Transition';

export enum TransitionState {
    ENTERING = 'entering',
    ENTERED = 'entered',
    EXITING = 'exiting',
    EXITED = 'exited',
}

export type StyledComponentsInnerRef =
    | ((instance: unknown) => void)
    | React.RefObject<HTMLElement | SVGElement | React.Component>;

export interface TransitionGroupChildBaseProps {
    transitionState?: TransitionState;
}

type TransitionCallbacks = Pick<
    TransitionProps,
    'onEntering' | 'onEntered' | 'onEnter' | 'onExit' | 'onExiting' | 'onExited'
>;

export interface StyledTransitionGroupProps<P> extends TransitionActions, TransitionCallbacks {
    childrenProps: P;
    timeoutEnter: number;
    timeoutExit: number;
    innerRef?: StyledComponentsInnerRef;
    children?: React.ReactNode;
}
